module.exports = (__webpack_require__(3))(18);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/View.js from dll-reference girder_plugin_large_image_annotation
// module id = 31
// module chunks = 0